/** @jsx h */
import {
  defineComponent,
  provide,
  h,
  ref,
  type InjectionKey,
  type PropType,
} from "vue";
import type {
  KernelConnection,
  IMasterKernelAPI,
  IViewportKernel,
  IViewport,
} from "@gratico/kernel";

// Re-export type
export type { KernelConnection } from "@gratico/kernel";

// Injection key for context
export const KernelContextKey: InjectionKey<
  ReturnType<typeof useKernelConnection>
> = Symbol("KernelContext");

// Store logic (wrapping in a function to match Alfama `signal`)
function useKernelConnection(props: {
  kernel: IViewportKernel;
  master: IMasterKernelAPI;
  viewport: IViewport;
}) {
  const connection: KernelConnection = {
    kernel: props.kernel,
    master: props.master,
    viewport: props.viewport,
  };
  return connection;
}

// KernelProvider component
export type KernelProviderProps = {
  kernel: IViewportKernel;
  master: IMasterKernelAPI;
  viewport: Record<string, any>;
};
export const KernelProvider = defineComponent({
  name: "KernelProvider",
  props: ["kernel", "master", "viewport"],
  setup(props, { slots }) {
    const connection = useKernelConnection(props);
    provide(KernelContextKey, connection);

    return () => slots.default?.();
  },
});
